import AwsS3Service from '../../../services/AwsS3Service';
import CategoryServiceV2 from '../../../services/v2/CategoryServiceV2';
import categoryUseCaseV2 from './categoryUseCaseV2';

const categoryFactoryV2 = categoryUseCaseV2({
  CategoryServiceV2: CategoryServiceV2(),
  AwsS3Service: AwsS3Service(),
});

export default categoryFactoryV2;
